import React, { useEffect, useMemo, useState } from "react";
import { fnGetDataSet } from "@shared/api/restApi";
import { global } from "@shared/libs/Global";
import { formatNumber, toNum } from "@shared/utils/CommonUtils";
import { icoSal01 } from "./icons";

interface Props {
  cdWidget?: string;
  nmWidget?: string;
  searchData?: any;
  refreshKey?: number;
}

const SnSysWidget005: React.FC<Props> = ({
  nmWidget,
  searchData,
  refreshKey,
}) => {
  const { userInfo } = global();
  const [dataSource, setDataSource] = useState<any>();

  const params = useMemo(
    () => ({
      cd_firm: searchData?.cd_firm || userInfo.cd_firm,
      dt: searchData?.dt,
    }),
    [searchData?.cd_firm, searchData?.dt, userInfo.cd_firm]
  );

  useEffect(() => {
    const fetchData = async () => {
      try {
        const param = {
          id: "sn_sys_widget_005_01",
          params,
        };
        const data: any = await fnGetDataSet(param);
        setDataSource(data?.[0]?.[0] || {});
      } catch (error) {}
    };

    fetchData();
  }, [params, refreshKey]);

  const rows = [
    {
      label: "신규수주액",
      value: formatNumber(toNum(dataSource?.am_so), { fractionDigits: 0 }),
      unit: "만원",
    },
    {
      label: "수주잔고",
      value: formatNumber(toNum(dataSource?.am_k_remain), {
        fractionDigits: 0,
      }),
      unit: "만원",
    },
    {
      label: "출하율",
      value: formatNumber(toNum(dataSource?.rt_isu), { fractionDigits: 1 }),
      unit: "%",
    },
    {
      label: "납기준수율",
      value: formatNumber(toNum(dataSource?.rt_dlv), { fractionDigits: 1 }),
      unit: "%",
    },
  ];

  return (
    <div className="flex h-full min-h-[198px] w-full flex-col rounded-lg border border-gray-100 bg-white px-4 py-3 shadow-sm">
      <div className="mb-5 flex items-center gap-3">
        <div className="aspect-square h-10 shrink-0">
          <img src={icoSal01} alt="" className="h-full w-full object-contain" />
        </div>
        <div className="truncate text-xl font-bold text-slate-900">{nmWidget}</div>
      </div>

      <div className="flex flex-col gap-2.5">
        {rows.map((row) => (
          <div
            key={row.label}
            className="flex items-baseline justify-between gap-3 text-base font-semibold"
          >
            <span className="shrink-0 text-slate-800">{row.label}</span>
            <span className="min-w-0 whitespace-nowrap text-right text-slate-900">
              {row.value}
              <span className="ml-1 text-sm font-semibold text-slate-700">
                {row.unit}
              </span>
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SnSysWidget005;
